export enum MedicalDataSource {
  COMMONWELL = "COMMONWELL",
  CAREQUALITY = "CAREQUALITY",
}
